import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import registerServiceWorker from "@/registerServiceWorker";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Phase 22 — register the PWA service worker after first paint.
registerServiceWorker();
